module.exports = __webpack_public_path__ + "static/media/parking.92fc84b6.svg";